import SearchIcon from "@/assets/images/icons/search.svg?inline";

export default {
  name: "faq_search_field",

  data() {
    return {
      skipFAQSearchQuery: true,
      searchString: "",
      faqSearch: []
    };
  },

  mounted() {
    if (this.$route.query.query) {
      this.searchString = this.$route.query.query;
    }
  },

  methods: {
    submitSearchRequest() {
      if (this.$route.name == "faq_search") {
        this.$emit("updateSearchResults", this.searchString);
      } else {
        this.$router.push({
          name: "faq_search",
          query: { query: this.searchString }
        });
      }
    }
  },

  components: {
    SearchIcon
  }
};
